import { FC, memo } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import { Person } from '@ucheba/ui/components/Person/desktop'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { IPopularPersonsProps } from '../types'

const Block = styled.div``

/** Список персон */
const PopularPersons: FC<IPopularPersonsProps> = (props) => {
  const { items, title } = props

  return (
    <Block>
      <Heading h2={title} spacing='null' />

      <Divider spacing='xlarge' />

      <List spacing='xlarge' bordered>
        {items.map((item, key) => {
          return (
            <ListItem key={key}>
              <Person
                name={item.fullName}
                hint={item.position}
                imgUrl={item.avatar?.fallbackUrl}
                imgSize='large'
                hintSize='medium'
                nameSize='h3'
                nameFontWeight='extrabold'
                nameSpacing='xxsmall'
              />
            </ListItem>
          )
        })}
      </List>
    </Block>
  )
}

export default memo(PopularPersons)
